var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakingNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2391_84286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2391_84286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 45.026C19.5696 45.026 20.1303 44.8004 20.5814 44.3493C21.0325 43.8982 21.2581 43.3375 21.2581 42.6673C21.2581 41.9971 21.0325 41.4364 20.5814 40.9853C20.1303 40.5342 19.5696 40.3087 18.8994 40.3087C18.2292 40.3087 17.6685 40.5342 17.2174 40.9853C16.7663 41.4364 16.5407 41.9971 16.5407 42.6673C16.5407 43.3375 16.7663 43.8982 17.2174 44.3493C17.6685 44.8004 18.2292 45.026 18.8994 45.026ZM16.8994 35.6933H20.8994V19.334H16.8994V35.6933ZM30.2327 44.6673H47.5661V40.6673H30.2327V44.6673ZM30.2327 34.0007H47.5661V30.0007H30.2327V34.0007ZM30.2327 23.334H47.5661V19.334H30.2327V23.334ZM11.7201 54.6673C10.373 54.6673 9.23275 54.2006 8.29941 53.2673C7.36608 52.334 6.89941 51.1938 6.89941 49.8466V14.1547C6.89941 12.8075 7.36608 11.6673 8.29941 10.734C9.23275 9.80065 10.373 9.33398 11.7201 9.33398H52.7454C54.0925 9.33398 55.2327 9.80065 56.1661 10.734C57.0994 11.6673 57.5661 12.8075 57.5661 14.1547V49.8466C57.5661 51.1938 57.0994 52.334 56.1661 53.2673C55.2327 54.2006 54.0925 54.6673 52.7454 54.6673H11.7201ZM11.7201 50.6673H52.7454C52.9508 50.6673 53.1388 50.5818 53.3094 50.4106C53.4805 50.24 53.5661 50.052 53.5661 49.8466V14.1547C53.5661 13.9493 53.4805 13.7613 53.3094 13.5906C53.1388 13.4195 52.9508 13.334 52.7454 13.334H11.7201C11.5147 13.334 11.3267 13.4195 11.1561 13.5906C10.985 13.7613 10.8994 13.9493 10.8994 14.1547V49.8466C10.8994 50.052 10.985 50.24 11.1561 50.4106C11.3267 50.5818 11.5147 50.6673 11.7201 50.6673Z",
    fill: "#16461A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakingNews);
export default __webpack_public_path__ + "static/media/breaking_news.ca90897f8f55ef8e77b060ca628db961.svg";
export { ForwardRef as ReactComponent };